<div class="container-fluid webView" [style.display]="showOnlyAddModal ? 'none' : ''">
    <!-- Header -->
    <div class="col-12 col-sm-12 webView"  style="padding: 15px 15px 0px 15px; padding-right: 0px;">
        <div class="col-5 col-sm-5" style="padding: 0px; display: inline-block;">
            <h3 class="lblHeader newHeader" style="display: inline-block;">
                Stores
            </h3>
            <span style="float: right;">
                <span class="btn orangeButton brdrRadius3" (click)="open(mymodal,0)" title="Add New Store"
                      style="position: relative; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px;">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span>  
        </div>    
        <div class="col-md-7 col-sm-7" style="padding: 0px; display: inline-block; text-align: right;">
            <span class="darkBlueButton brdrRadius3" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px !important;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
            </span>
        </div>
    </div>
    
    
        <div class="col-md-12" style="padding: 0px 15px;">
            <!-- Right -->
            <div class="col-md-12" style="padding: 15px 0px;">
                <!-- Right -->
                <div class="col-md-5 mainCardHeader inLneBlk" style="padding: 0px; vertical-align:middle;">
                            <div id="divScrID" class="col-md-12" style="padding: 0px;">
                                <div class="col-md-12 {{changeColor(i % 7)}}" *ngFor="let s of stores let i = index" style="margin-bottom: 10px;color: #e88421; background: white;border-radius: 3px !important;border: 1px solid;"> 
                                    <div class="row">                          
                                        <div class="col-9">
                                            <span style="font-size: 13px;">{{s.sNm}}</span>                       
                                        </div>       
                                        <div class="col-3" style="text-align: right;">
                                            <div class="lableBtnOrange" style=" margin-right: 4px; font-size: 12px;" title="Edit" (click)="open(editModal,s.StrID)">
                                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                            </div>                                    
                                        </div>
                                    </div>
                                    <div class="row" style="margin: 0px;">
                                        <div class="inLneBlk" *ngFor="let u of s.UIDs let j = index" style="margin-bottom: 5px; color: #777; font-size: 12px;">                                                                       
                                            <span *ngIf="j == 0">
                                                <span>
                                                    <i class="fa fa-circle" style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                                </span> 
                                                <span style="padding: 5px;">
                                                      {{u.Name}} 
                                                </span>
                                                <span *ngIf="s.UIDs.length != 1">
                                                    <i class="fa fa-circle" style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                                </span>
                                            </span>
                                            <span *ngIf="j != 0 && !(j == (s.UIDs.length-1))">
                                                <span style="padding: 5px;">
                                                    {{u.Name}}
                                                </span>
                                                <i class="fa fa-circle" style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                            </span>
                                            <span *ngIf="j == (s.UIDs.length-1)  && j != 0" style="padding: 5px;">
                                                {{u.Name}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       
                        <div class="bgWhite" style="padding-top: 15px; border-radius: 3px;"  *ngIf="stores.length == 0">
                            <div class="nrf brdrRadius3" (click)="open(mymodal, 0);">
                                Click here to add a store.
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <!-- <div class="col-md-6" style="display: inline-block;margin-top: 15px;"> 
            <span style="float: left;">
                <span class="label" (click)="open(mymodal,0)"
                    style="border-radius: 15%; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i><span>Add</span>
                </span>
            </span>
        </div> -->

   

</div>

<div class="container-fluid mobView pad0" [style.display]="showOnlyAddModal ? 'none' : ''">
    <!-- Header -->
    <div class="col-12 col-md-12 bgWhite padHeder">
        <span style="font-size: 20px; margin-right: 10px;"(click)="back()">
            <i class="fa fa-chevron-left"></i>
        </span>
        <h4 style="display: inline-block;">Stores</h4>
        <span style="float: right;">
            <span class="label brdrRadius3 addOrgBtnM" (click)="open(mymodal, 0)"                >
                <span style="margin-right: 7px;"><i class="zmdi zmdi-plus"></i></span>
                <span>Add</span>
            </span>          
        </span>
    </div>

    <!-- Body -->
   
        <div class="col-md-12" style="padding: 0px;">
            <!-- Right -->
            <div class="col-md-6 mainCardHeader inLneBlk" style="padding: 0px; vertical-align: top;">
                        <div id="divScrID" class="col-md-12">
                            <div *ngFor="let s of stores let i = index" class="col-md-12 orngBadgeM" style="margin-bottom: 8px;"> 
                                <div class="row">  
                                                      
                                    <div class="col-9 font13" style="padding: 0px 0px 5px 15px;">
                                        <span>{{s.sNm}}</span>                        
                                    </div>       
                                    <div class="col-3 font13" style="text-align: right;">
                                        <div style="border-radius: 50%; margin-right: 4px;cursor: pointer;" title="Edit" (click)="open(editModal,s.StrID)">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </div>                                    
                                    </div>
                                </div>
                                <div class="row" style="margin: 0px;">
                                    <div class="inLneBlk font12" *ngFor="let u of s.UIDs let j = index" style="margin-bottom: 10px; color: #777;">                                                                       
                                        <span *ngIf="j == 0">
                                            <span>
                                                <i class="fa fa-circle" style="font-size: 8px; position: relative; top: -2.5px;"></i>
                                            </span> 
                                            <span style="padding: 5px;">
                                                  {{u.Name}} 
                                            </span>
                                            <span *ngIf="s.UIDs.length != 1">
                                                <i class="fa fa-circle" style="font-size: 8px; position: relative; top: -2.5px;"></i>
                                            </span>
                                        </span>
                                        <span *ngIf="j != 0 && !(j == (s.UIDs.length-1))">
                                            <span style="padding: 5px;">
                                                {{u.Name}}
                                            </span>
                                            <i class="fa fa-circle" style="font-size: 8px; position: relative; top: -2.5px;"></i>
                                        </span>
                                        <span *ngIf="j == (s.UIDs.length-1)  && j != 0" style="padding: 5px;">
                                            {{u.Name}}
                                        </span>

                                        <!-- <span *ngIf="s.UIDs == ''">sp</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                   
                    <div class="bgWhite" style="padding-top: 15px; border-radius: 3px;"  *ngIf="stores.length > 0">
                        <div class="nrf" (click)="open(mymodal, 0);" style="margin-left: 15px;">
                            Click here to add a store.
                        </div>
                    </div>
            </div>
        </div>
       
</div>

<!--Add store-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header bgModal" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-9 col-xs-9" style="padding-left: 0px;">
                    <h4 class="modal-title newHeader"><span id="ApntmntHdr" style="font-size: 22px;">Add Store </span></h4>
                </div>
                <div class="col-md-3 col-3 col-xs-3" style="padding-right: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body bgModal" style="padding: 0px;">
        <div class="col-md-12 font13" style="padding: 0px">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px;">
                <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;">
                    <label class="label-new" style="margin-bottom: 0; padding: 0; font-size: 13px;">Store</label>
                    <input type="text" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="data.sNm"  maxlength="50"  style="text-indent: 2px; background-color: white !important;" captalize-first>
                </div>
            </div>
            <div class="col-md-12 col-xs-12 col-12" *ngIf="ISEGST"
             style="margin-top: 15px; display: inline-block;">
                <!-- <div class="col-md-3 col-xs-3 col-3" style="display: inline-block; padding: 0px;">
                    <span style="font-size: 13px;">Select Location</span>
                </div> -->
                <div class="col-md-12 col-xs-12 col-12"  style="display: inline-block; padding: 0px;">
                    <label class="label-new" style="margin-bottom: 0; font-size: 13px;">Location</label>
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="data.LID" (ngModelChange)="changeGSTLoc();" style="display: inline-block; font-size: 13px;position: relative; top: -7px; background: inherit; cursor: pointer; vertical-align: text-top; background-color: white !important;">
                        <option [ngValue]="0">Select Location</option>
                        <option *ngFor="let g of MultiGSTList" [ngValue]="g.ID">{{g.Nm}} - {{g.SNm}} ({{g.GST}})</option>
                    </select>
                </div>
            </div>
            
        </div>

        <div class="col-md-12 col-xs-12 col-12" style="margin-bottom: 10px; display: inline-block; margin-top: 5px;">
            <div class="col-md-4 col-12 font13" style="display: inline-block; padding: 5px; padding-left: 0;">                                
                <label style="cursor: pointer; margin: 0px;">
                    <input type="checkbox" class="chkbox-darkblue" style="vertical-align: text-top; outline: none;" [(ngModel)]="data.isJobStore">
                    <span style="padding: 6px;">Jobwork Store</span>
                </label>
            </div>
            <div *ngIf="data.isJobStore" class="col-md-12 col-xs-12 col-12"  style="display: inline-block; padding: 0px;">
                <label class="label-new" style="margin-bottom: 0; font-size: 13px;">Supplier</label>
                <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="data.relID" 
                    style="display: inline-block; font-size: 13px;position: relative; top: -7px; background: inherit; cursor: pointer; vertical-align: text-top; background-color: white !important;">
                    <option [ngValue]="0">Select Supplier</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [ngValue]="s.RI">{{s.Cmp}}</option>
                </select>
            </div>
        </div>

        <div class="col-md-12">
            <div class="col-md-4 col-12 font13" [style.marginTop]="ISEGST ? '' : '10px'" *ngFor="let u of rights let i = index" style="display: inline-block; padding: 5px; padding-left: 0px;">                                
                <label style="cursor: pointer; margin-bottom: 0px;">
                    <input type="checkbox" class="chkbox-darkblue" style="vertical-align: text-top;" [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked">
                    <span style="padding:6px">{{u.Name}}</span>
                </label>
            </div>
        </div>

        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <div style="display: flex; column-gap: 10px; height: 27px !important; margin-top: 10px;">
                <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px; font-size: 14px;" (click)="addStore(data.sNm,rights)">
                    <i class="fa fa-check" style="margin-right: 5px; font-size: 14px !important;"></i>
                    <span style="font-size: 14px !important;">Save</span>
                </span>
                <span class="btn-darkBlue brdrRadius3 mobView" style="padding: 0px 10px;" (click)="closeModal()" >
                    <i class="fa fa-close" style="margin-right: 5px;font-size: 14px !important;"></i>
                    <span style="font-size: 14px !important;">Close</span>
                </span>
            </div>
        </div>
    </div>
</ng-template>

<!--Edit store-->
<ng-template #editModal let-modal>
    <!--Header-->
    <div class="modal-header bgModal" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-9 col-xs-9" style="padding-left: 0px;">
                    <h4 class="modal-title newHeader"><span id="ApntmntHdr" style="font-size: 22px;">Edit Store</span></h4>
                </div>
                <div class="col-md-3 col-3 col-xs-3" style="padding-right: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()"></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body bgModal" style="padding: 0px;">
        <div class="col-md-12 font13" style="padding: 0px">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px;">
                <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;">
                    <label class="label-new" style="margin-bottom: 0; padding: 0; font-size: 13px;">Store</label>
                    <input type="text" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="oldStoreName" maxlength="50" style="text-indent: 2px; background-color: white !important;" captalize-first>
                </div>
            </div>
            <div class="col-md-12 col-xs-12 col-12" *ngIf="ISEGST" style="margin-top: 15px; display: inline-block;">
                <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px;">
                    <label class="label-new" style="margin-bottom: 0; font-size: 13px;">Location</label>
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="data.LID" (ngModelChange)="changeGSTLoc();" style="display: inline-block; font-size: 13px;position: relative; top: -7px; background: inherit; cursor: pointer; vertical-align: text-top; background-color: white !important;">
                        <option [ngValue]="0">Select Location</option>
                        <option *ngFor="let g of MultiGSTList" [ngValue]="g.ID">{{g.Nm}} - {{g.SNm}} ({{g.GST}})</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-xs-12 col-12" style="margin-bottom: 10px; display: inline-block; margin-top: 5px;">
            <div class="col-md-4 col-12 font13" style="display: inline-block; padding: 5px; padding-left: 0;">                                 
                <label style="cursor: pointer; margin: 0px;">
                    <input type="checkbox" class="chkbox-darkblue" style="vertical-align: text-top; outline: none;" [(ngModel)]="data.isJobStore">
                    <span style="padding: 6px;">Jobwork Store</span>
                </label>
            </div>
            <div *ngIf="data.isJobStore" class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px;">
                <label class="label-new" style="margin-bottom: 0; font-size: 13px;">Supplier</label>
                <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="data.relID" style="display: inline-block; font-size: 13px;position: relative; top: -7px; background: inherit; cursor: pointer; vertical-align: text-top; background-color: white !important;">
                    <option [ngValue]="0">Select Supplier</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [ngValue]="s.RI">{{s.Cmp}}</option>
                </select>
            </div>
        </div>

        <div class="col-md-12">
            <div class="col-md-4 col-12 font13" [style.marginTop]="ISEGST ? '' : '10px'" *ngFor="let u of editRights let i = index" style="display: inline-block; padding: 5px; padding-left: 0px;">                                 
                <label style="cursor: pointer; margin-bottom: 0px;">
                    <input type="checkbox" class="chkbox-darkblue" style="vertical-align: text-top;" [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked">
                    <span style="padding: 6px;">{{u.Name}}</span>
                </label>
            </div>
        </div>

        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <div style="display: flex; column-gap: 10px; height: 27px !important; margin-top: 10px;">
                <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px; font-size: 14px;" (click)="editStore(oldStoreName,editRights)">
                    <i class="fa fa-check" style="margin-right: 5px; font-size: 14px !important;"></i>
                    <span style="font-size: 14px !important;">Save</span>
                </span>
                <span class="btn-darkBlue brdrRadius3 mobView" style="padding: 0px 10px;" (click)="closeModal()">
                    <i class="fa fa-close" style="margin-right: 5px;font-size: 14px !important;"></i>
                    <span style="font-size: 14px !important;">Close</span>
                </span>
            </div>
        </div>
    </div>
</ng-template>



  
